import React, { useState, useMemo } from "react";
import { Modal, Button } from "react-bootstrap";

function InformationModal({
  message,
  onClose,
}: {
  message: String;
  onClose: () => void;
}) {
  const [closed, setClosed] = useState(false);
  const show = useMemo(() => !closed, [closed]);

  const onCloseModal = () => {
    setClosed(true);
    onClose();
  };

  return (
    <Modal show={show} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Información</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onCloseModal}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default InformationModal;
